import React from 'react';
import classes from './BigButton.module.scss';

const BigButton = ({ className, style, children, clicked, type = 'button', grad, disabled }) => {
  const rootClass = [classes.BigButton];
  if (className) rootClass.push(className);
  if (disabled) rootClass.push(classes.Disabled);
  if (grad) rootClass.push(classes.Grad);

  return (
    <button type={type} className={rootClass.join(' ')} style={style ? style:{}} 
      onClick={(e)=> !disabled && clicked ? clicked(e) : 0}>
      {children}
    </button>
  );
}

export default BigButton;